// extracted by mini-css-extract-plugin
export var columnList = "_c2-0";